import { useSearchParams } from 'react-router-dom';
import { useParams } from 'src/routes/hooks';
import SignupView from 'src/sections/signup/view';
import { Helmet } from 'react-helmet-async';

export default function SignupPage() {
  // hooks
  const [searchParams] = useSearchParams();
  const token = searchParams.get('token');

  return(
    <>
        <Helmet>
            <title> HireIntel AI - Signup Page</title>
            <meta name="description" content="Signup for HireIntel clients to manage screening of different job openings."/>
        </Helmet> 
        <SignupView token={token} />
  </>
  );
}
